import { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { routeSlice } from 'redux/reducers';
import Images from 'assets/Images';
import { useFetch } from 'hooks';
import { AnimatePresence, motion } from 'framer-motion';
import { menuList } from 'config';
import './style.scss';
import { SelectMenu } from 'components/generic';
import { getValuesById } from 'utils';

const Header = () => {
	const [title, setTitle] = useState();
	const [menuToggler, setMenuToggler] = useState(false);
	const [profileLogo, setProfileLogo] = useState('');
	const api = useFetch();

	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();
	const dropdownOptionsRef = useRef();

	const clientConfig = useSelector(state => state.clientData)?.data;
	const clientList = useSelector(state => state.clientList)?.data;

	const clientDropdownList = useMemo(() => clientList?.map(el => ({ key: el?.c_id, value: el?.c_name })), [clientList]);

	const userDetails = localStorage.getItem('_ud');
	const selectedClient = localStorage.getItem('c_id');
	const userInfo = userDetails && JSON.parse(userDetails);

	useEffect(() => {
		const _ud = localStorage.getItem('_ud') && JSON.parse(localStorage.getItem('_ud'));
		_ud && setProfileLogo(_ud?.attributes?.profilePhoto?.at());
	}, [clientConfig]);

	useEffect(() => {
		const pageName = window?.location?.pathname?.split('/');
		const result = pageName[pageName?.length - 1]?.replace(/-/g, ' ');
		setTitle(result);
	}, [location]);

	const listClickHandler = e => {
		['team-members', 'my-profile']?.includes(e) && navigate(e);
		e === 'logout' && handleLogout();
		setMenuToggler(false);
	};

	const handleLogout = async () => {
		await api({ url: `client/v1/logout`, method: 'get', hideErrorToaster: true, refreshToken: true });
		localStorage.clear();
		dispatch(routeSlice?.actions?.routeReducer(''));
		navigate('');
	};

	// outside click handle function
	const handleClickOutside = useCallback(
		event => {
			if (dropdownOptionsRef?.current && !dropdownOptionsRef?.current?.contains(event?.target)) {
				menuToggler && setMenuToggler(false);
			}
		},
		[setMenuToggler, menuToggler]
	);

	// outside click handler
	useEffect(() => {
		document.addEventListener('click', handleClickOutside, true);
		return () => {
			document.removeEventListener('click', handleClickOutside, true);
		};
	}, [menuToggler, handleClickOutside]);

	const setClient = e => {
		localStorage.setItem('c_id', e);
		window.location.reload();
	};

	
	return (
		<>
			<div className='header__container'>
				<h1 className='header'>{title}</h1>

				<div className='display-flex'>
					{process.env.REACT_APP_STANDALONE_APP !== 'Y' && (
						<div className='header__client'>
							<SelectMenu last menuOptions={clientDropdownList || []} placeholder='Select Client' value={getValuesById(clientDropdownList, selectedClient)} onChange={setClient} />
						</div>
					)}
					<div className='header__logo' onClick={() => setMenuToggler(prevState => !prevState)}>
						<img className='header__logo__img' src={!['undefined', 'null', undefined, null, '']?.includes(profileLogo) ? profileLogo : Images.user} alt='User' />
						<img src={Images.downArrow} alt='Arrow' />
					</div>
				</div>
			</div>

			<AnimatePresence>
				{menuToggler && (
					<motion.div initial={{ y: -10, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: -10, opacity: 0 }} transition={{ duration: 0.2 }} ref={dropdownOptionsRef} className='header__profile-menu'>
						<div className='header__profile-menu__admin'>
							<h4>
								{userInfo?.firstName} {userInfo?.lastName}
							</h4>
							<p>{userInfo?.roles?.at()?.name}</p>
						</div>
						<ul className='header__profile-menu__list'>
							{menuList?.map((el, i) => (
								<li key={i} onClick={() => listClickHandler(el?.key)}>
									<img src={Images[el?.key]} alt={el?.key} />
									{el?.value}
								</li>
							))}
						</ul>
					</motion.div>
				)}
			</AnimatePresence>
		</>
	);
};

export default Header;
